module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs middle-xs pt-20 mb-12"
  }, [_c('img', {
    staticStyle: {
      "height": "180px"
    },
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": ""
    }
  }), _vm._v(" "), (_vm.environment_is_staging) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', [_vm._v("THIS IS THE STAGING ENVIRONMENT")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://go.parlayideas.com"
    }
  }, [_vm._v("Please access the official Parlay app by clicking here")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-f7380a8c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/authentication/components/landingPageTitle.vue
// module id = 2305
// module chunks = 61